/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useLabels, useRequestData } from 'wsm-common-data';
import useFetchFacets from '../../hooks/useFetchFacets';
import { getFilerModal } from '../../utilities/selector';
import { MODAL } from '../../constant';
import Icon from '../Icon';

const FacetFilters = (props) => {
	const { filters } = props.facetData;
	const selectedFilter = useSelector(getFilerModal);
	const [showClearFilter, setShowClearFilter] = useState(false);
	const [chipFilter, setChipFilter] = useState(null);
	const [removeAllFacet, setRemoveAllFacet] = useState(false);

	const { windowId } = useRequestData();
	const labels = useLabels();

	useFetchFacets(chipFilter, MODAL, removeAllFacet);

	useEffect(() => {
		if (filters?.length > 0) {
			setShowClearFilter(true);
		} else {
			setShowClearFilter(false);
		}
	}, [filters]);

	const handleUpdateA11yMessage = (a11yContent) => {
		const a11yStatus = document.getElementById(`${windowId}-a11y-status`);
		const a11yMessageId = `${windowId}-a11y-message`;
		document.getElementById(a11yMessageId)?.remove();
		setTimeout(() => {
			a11yStatus.insertAdjacentHTML(
				'afterend',
				`<div aria-live="polite" id="${a11yMessageId}" class="sr-only" aria-atomic="true">${a11yContent}</div>`
			);
		}, 500);
	};

	const removeFilter = useCallback(
		(event) => {
			const { id, value, textContent } = event.currentTarget;
			const removeAll = value === 'remove-all';

			if (removeAll) {
				handleUpdateA11yMessage(labels.get('ALL_FILTERS_REMOVED'));
				setChipFilter({ compositeType: [] });
				setRemoveAllFacet(true);
			} else {
				setChipFilter(
					selectedFilter[id]
						? {
								[id]: selectedFilter[id].filter(
									(item) => item !== value
								)
						  }
						: selectedFilter
				);
				setRemoveAllFacet(false);
				handleUpdateA11yMessage(
					`${textContent} ${labels.get('FILTER_REMOVED')}`
				);
			}
		},
		[selectedFilter]
	);

	const filterList = filters?.map((filter) => {
		/* TODO handle no internetPrice'sLabel in filters response from WIS */

		const { label: filterLabel } = filter;
		if (filter.id === 'internetPrice') {
			filter.values.forEach((item) => {
				if (!item.label) {
					// eslint-disable-next-line no-param-reassign
					item.label = labels.get('INCLUDE_NO_PRICE_AVAILABLE');
				}
			});
		}
		return filter.values.map((item) => {
			return (
				<li className="mt-3">
					<button
						type="button"
						className="pill chip chip-default chip-condensed facet-filter"
						aria-label={labels
							.get('FILTER_VALUE_CLICK_TO_REMOVE')
							.replace('{filter}', filterLabel)
							.replace('{value}', item.label)}
						id={filter.id}
						value={item.value}
						onClick={removeFilter}
					>
						{item.label}
						<Icon name="remove2" className="ml-1" />
					</button>
				</li>
			);
		});
	});

	return (
		<div>
			{filters?.length > 0 && (
				<ul className="d-flex facet-filter align-items-center flex-wrap list-inline">
					{filterList}
					{showClearFilter && (
						<li className="mt-3">
							<button
								className="text-link"
								type="button"
								value="remove-all"
								onClick={removeFilter}
							>
								{labels.get('CLEAR_FILTERS')}
							</button>
						</li>
					)}
				</ul>
			)}
		</div>
	);
};

FacetFilters.propTypes = {
	facetData: PropTypes.shape({
		facets: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
		filters: PropTypes.arrayOf(PropTypes.shape({})).isRequired
	}).isRequired
};

export default FacetFilters;
